import React from 'react';
import MarkdownIt from 'markdown-it';
import { Card, Typography, Divider } from 'antd';

const mdParser = new MarkdownIt({
    html: true, // Enable HTML tags in source
    linkify: true, // Autoconvert URL-like text to links
    typographer: true // Enable some smart replacements
});

const ViewableResponse = ({ markdownText, title }) => {
    return (
        <Card
            bordered={false}
            style={{
                background: 'transparent',
                maxWidth: '800px',  // Limit the width for better readability
            }}
        >
            {title && <><Typography.Title level={3}>{title}</Typography.Title><Divider/></>}
            <div style={{
                lineHeight: 2,
                fontSize: '14px',
            }} dangerouslySetInnerHTML={{ __html: mdParser.render(markdownText) }} />
        </Card>
    );
};

export default ViewableResponse;
